export const ORGANISATION_SUPPLIER_STATE_VALUES = ['ACTIVE', 'ARCHIVED', 'INACTIVE', 'PENDING'] as const
export type OrganisationSupplierState = (typeof ORGANISATION_SUPPLIER_STATE_VALUES)[number]

export const SUPPLIER_ONLINE_RESOURCE_STATUS_VALUES = ['public', 'private', 'unavailable', 'notFound'] as const
export type SupplierOnlineResourceStatus = (typeof SUPPLIER_ONLINE_RESOURCE_STATUS_VALUES)[number]

export const SUPPLIER_ONLINE_RESOURCE_TYPE_VALUES = [
  'trustCenter',
  'soc2',
  'iso27001',
  'privacyPolicy',
  'dpa',
  'penTestReport',
  'governmentBusinessRegistry',
  'subprocessorList',
  'csaStar',
  'pciDSS',
  'cyberEssentials',
  'statusPage',
] as const
export type SupplierOnlineResourceType = (typeof SUPPLIER_ONLINE_RESOURCE_TYPE_VALUES)[number]

export const INTERNAL_CONTACT_ROLE_VALUES = ['business-owner', 'it-owner', 'budget-holder', 'other'] as const
export type InternalContactRole = (typeof INTERNAL_CONTACT_ROLE_VALUES)[number]

/**
 * The kinds an assignment to a supplier can have: the internal-contact roles, plus product owner —
 * a product's `business_owner_id`, which carries no role column of its own.
 *
 * Authorization resolves capability per kind, so a row whose stored role is outside this set yields
 * no assignment and confers nothing.
 */
export const SUPPLIER_ASSIGNMENT_KIND_VALUES = [...INTERNAL_CONTACT_ROLE_VALUES, 'product-owner'] as const
export type SupplierAssignmentKind = (typeof SUPPLIER_ASSIGNMENT_KIND_VALUES)[number]

/** Narrows a stored `internal_contacts.role` to a known assignment kind; `null` when unrecognised. */
export const toSupplierAssignmentKind = (role: string): SupplierAssignmentKind | null =>
  SUPPLIER_ASSIGNMENT_KIND_VALUES.find((kind) => kind === role) ?? null
